module.exports = __webpack_public_path__ + "img/alerts_delete.80be6e9e.svg";